import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { ViewportScroller } from '@angular/common';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-form-nav-button',
  templateUrl: './form-nav-button.component.html',
  styleUrls: ['./form-nav-button.component.scss']
})
export class FormNavButtonComponent implements OnInit, OnDestroy {

  @Input() sectionName!: string;
  @Input() displaySectionName!: string;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(protected navigationService: NavigationService, private responsive: BreakpointObserver, protected scroller: ViewportScroller) { }

  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sizeChangeSubscription.unsubscribe();
  }

  advanceForm() {
    this.navigationService.saveFormandSendUsanFormSectionStatesUpdate(this.sectionName);
    
    if (!this.mobileDeviceSize)
      this.scroller.scrollToAnchor('tabs-bar');
  }

  get isMobileDeviceSize() : boolean {
    return this.mobileDeviceSize;
  }
}
